/* LumetierFooterCredit — clean inline "Site by Lumetier" attribution link
   that lives inside each tenant template's footer bottom row.

   Why this exists alongside the rotated TenantSignature:
   • TenantSignature is intentionally subtle (rotated 9px sidebar caption) —
     a brand whisper for readers who notice details.
   • LumetierFooterCredit is the discoverable text link — what most visitors
     read when they reach the bottom of a tenant site. It drives the
     marketing flywheel (tenant sites → lumetiercreatives.com).

   Both surfaces respect the same `lumetier_credit_hidden` flag from
   site_settings so a tenant can hide the entire credit in one move.

   The component is intentionally tiny + style-agnostic — each Layout
   passes the `className` it wants so the credit blends with that
   template's footer typography (uppercase tracked-out caption for
   Editorial/Bold/Journal, lowercase tracked-out for Minimal). */

import React from "react";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { LUMETIER_HREF } from "./TenantSignature";

export default function LumetierFooterCredit({ className = "", testid = "lumetier-footer-credit" }) {
  const { settings } = useSiteSettings();
  if (settings?.lumetier_credit_hidden) return null;
  return (
    <a
      href={LUMETIER_HREF}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`hover:opacity-100 transition-opacity ${className}`}
      style={{ opacity: 0.7 }}
    >
      Site by{" "}
      <span
        style={{
          fontStyle: "italic",
          fontFamily: "var(--tenant-serif, 'Cormorant Garamond', serif)",
          textTransform: "none",
          letterSpacing: "0.02em",
        }}
      >
        Lumetier
      </span>
    </a>
  );
}
